import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=20904d87"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"
import style0 from "./Toggle.vue?vue&type=style&index=0&id=20904d87&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports